import styled from "styled-components";
import { useChainData } from "@sablier/v2-hooks";
import { useT } from "@sablier/v2-locales";
import { _ } from "@sablier/v2-mixins";
import { Card, Characteristic } from "~/client/components/molecules";
import { useStreamCurrent, useToken } from "~/client/hooks";

const WrapperPartial = styled(Card)`
  & > * {
    width: ${(props) => props.theme.sizes.streamDetailsWidth};
    border: 2px solid ${(props) => props.theme.colors.border};
    background-color: ${(props) => props.theme.colors.modalDetailsBackground};
  }
`;

const List = styled.div`
  ${(props) => props.theme.styles.column}
  & {
    row-gap: calc(${(props) => props.theme.sizes.edge} * 1);
    width: 100%;
    padding-top: calc(${(props) => props.theme.sizes.edge} * 3 / 2);
    padding-bottom: calc(${(props) => props.theme.sizes.edge} * 1 / 2);
  }
`;

const Wrapper = styled(WrapperPartial)`
  ${(props) => props.theme.medias.maxLG} {
    width: 100%;
    & > * {
      width: 100%;
    }
  }

  ${(props) => props.theme.medias.maxMD} {
    ${List} {
      row-gap: calc(${(props) => props.theme.sizes.edge} * 3 / 4);
      padding-top: calc(${(props) => props.theme.sizes.edge} * 1);
    }
  }
`;

function Characteristics() {
  const { preview, stream } = useStreamCurrent();

  const { chain } = useChainData(stream?.chainId);
  const token = useToken({ token: stream?.token });
  const { t } = useT();

  if (_.isNil(stream)) {
    return false;
  }

  return (
    <Wrapper title={_.capitalize(t("words.overview"))}>
      <List>
        <Characteristic.Chain chain={chain} />
        <Characteristic.Status status={preview.status} />
        <Characteristic.Identifier
          category={stream.category}
          id={_.toAlias(stream.alias)}
        />
        {stream.isBatched && (
          <Characteristic.Batch
            label={stream.batch?.label || ""}
            size={stream.batch?.size || 0}
          />
        )}
        <Characteristic.Sender
          chainId={stream.chainId}
          address={stream.proxied ? stream.proxender : stream.sender}
          proxy={stream.proxied ? stream.sender : undefined}
        />
        <Characteristic.Recipient
          chainId={stream.chainId}
          address={stream.recipient}
        />
        <Characteristic.Shape
          amount={stream.depositAmount.humanized.toString()}
          category={stream.category}
          shape={stream.shape}
          token={token}
        />

        <Characteristic.Cancelable
          was={stream.wasCancelable}
          is={stream.isCanceled || stream.isSettled}
        />
        <Characteristic.Transaction
          chainId={stream.chainId}
          hash={stream.hash}
        />
        <Characteristic.Contract
          chainId={stream.chainId}
          address={stream.contract}
          tokenId={stream.tokenId}
        />
      </List>
    </Wrapper>
  );
}

export default Characteristics;
